// extracted by mini-css-extract-plugin
export var sliderRange = "_kz-2";
export var sliderRoot = "_kz-0";
export var sliderThumb = "_kz-3";
export var sliderTrack = "_kz-1";